const doc = $(document);

doc.on('scroll', (e) => {

    const signpost = $('.signpost');
    let h;

    if($('.page-home').length >= 1) {
        h = ($('.hero').first().height() / 2) - signpost.width();
    } else {
        h = $('.hero-half').first().height() - parseInt(signpost.css('top'), 10) - signpost.width();
    }

    if(doc.scrollTop() > h) {
        signpost.addClass('body');
    } else {
        signpost.removeClass('body');
    }
});



// WEBPACK FOOTER //
// ./src/js/signpost.js